module.exports = {
  menuData: [
    {
      path: 'errorCode',
      title: '错误码排查',
      docId: 'doc1'
    },
    {
      path: 'debug',
      title: 'API 调试工具',
      docId: 'doc2'
    }
  ],

  codeInfo: [
    {
      httpCode: '400',
      apiCode: '40000001',
      meaning: 'BusinessError',
      solution: ['错误原因：业务接口的内部错误', '解决方案：', '联系搜车业务方解决'],
    },
    {
      httpCode: '400',
      apiCode: '40000001',
      meaning: 'Error: no valid node in service',
      solution: [
        '错误原因：找不到内部业务接口的dubbo服务',
        '解决方案：',
        '联系搜车业务方解决',
      ],
    },
    {
      httpCode: '400',
      apiCode: '40000001',
      meaning: 'Error: not found method **  for service ***',
      solution: [
        '错误原因：dubbo接口没有对应的方法',
        '解决方案：',
        '联系搜车业务方解决',
      ],
    },
    {
      httpCode: '401',
      apiCode: '40100001',
      meaning: 'lack of sign or token',
      solution: [
        '错误原因：请求体缺少签名',
        '解决方案：',
        '1. 在 post body中添加 "sign" 字段',
        ' 2. 在 http headers 添加 "x-izayoi-sign" 字段 (适用于老版本开放平台)',
      ],
    },
    {
      httpCode: '401',
      apiCode: '40100002',
      meaning: 'lack of timestamp',
      solution: ['错误原因：请求体缺少时间戳', '解决方案：', '在 post body中添加 "timestamp" 字段'],
    },
    {
      httpCode: '401',
      apiCode: '40100003',
      meaning: 'lack of appKey',
      solution: [
        '错误原因：请求体缺少appKey',
        '解决方案：',
        '1. 首先确认是post请求，body是json格式',
        '2. 在 post body中添加 "appKey" 字段',
      ],
    },
    {
      httpCode: '401',
      apiCode: '40100004',
      meaning: 'not partner',
      solution: [
        '错误原因：无法找到合作商',
        '解决方案：',
        '1. 首先确认是appKey和appSecret都不为空',
        '2. 检查appKey的正确性，是不是此环境的appKey',
      ],
    },
    {
      httpCode: '401',
      apiCode: '40100005',
      meaning: 'sign expired',
      solution: [
        '错误原因：请求过期',
        '解决方案：',
        '1. 超过5min的签名，都报请求过期',
        '2. 请基于当前时间戳签名并重新发起请求',
      ],
    },
    {
      httpCode: '401',
      apiCode: '40100006',
      meaning: 'sign invalid',
      solution: [
        '错误原因：验签失败',
        '解决方案：',
        '1. 首先检查body的各字段是否正确，尤其要注意，data的值是json格式的字符串',
        '2. 检查验签步骤是否正确，详情见鉴权文档',
      ],
    },
    {
      httpCode: '403',
      apiCode: '40300001',
      meaning: 'ip permission denied',
      solution: [
        '错误原因：白名单限制，(预发&线上环境都是有白名单限制)',
        '解决方案：',
        '1. 确认贵公司的对外出口ip,不清楚的请咨询贵公司的运维',
        '2. 联系搜车合作方，提交白名单申请',
      ],
    },
    {
      httpCode: '403',
      apiCode: '40300002',
      meaning: 'api permission denied',
      solution: [
        '错误原因：api权限限制',
        '解决方案：',
        '联系搜车业务方解决',
      ],
    },
    {
      httpCode: '404',
      apiCode: '40400001',
      meaning: 'api not exist',
      solution: [
        '错误原因：api权限限制',
        '解决方案：',
        '1.确认调用接口是否填对',
        '2.联系搜车业务方解决',
      ],
    },
    {
      httpCode: '429',
      apiCode: '42900001',
      meaning: 'app traffic over-loading',
      solution: [
        '错误原因：请求接口所属的应用流量超限',
        '解决方案：',
        '1.等待应用流量重置周期，流量重置后请求',
        '2.联系搜车业务方，增加应用流量额度或紧急重置应用流量',
      ],
    },
    {
      httpCode: '429',
      apiCode: '42900002',
      meaning: 'api traffic over-loading',
      solution: [
        '错误原因：请求接口流量超限',
        '解决方案：',
        '1.等待应用流量重置周期，流量重置后请求',
        '2.联系搜车业务方，增加应用流量额度或紧急重置应用流量',
      ],
    },
    {
      httpCode: '500',
      apiCode: '50000001',
      meaning: 'InternalServerError',
      solution: ['错误原因：开放平台错误', '解决方案：', '联系搜车业务方解决'],
    },
    {
      httpCode: '502',
      apiCode: '502',
      meaning: ' Bad Gateway',
      solution: ['错误原因：开放平台错误', '解决方案：', '联系搜车业务方解决'],
    },
  ]
};
